import axios from 'axios';
import store from '@/store/store'
const instance = axios.create();

// instance.defaults.baseURL = 'https://api.example.com';
// instance.defaults.baseURL = 'https://api.competency.mfu.ac.th';
// instance.defaults.baseURL = 'http://127.0.0.1:8082';
instance.defaults.baseURL = 'https://api-competency.mfu.ac.th/';
// instance.defaults.timeout = 5000;

instance.defaults.headers = {
  "Content-Type": "application/json",
  // "api-version": "1.0",
  // "X-Access-Token": `${store.state.XAccessToken}`,
  // "X-Access-Token": "0f2a1d01e9c887bfa212bfc9def6e4145253f105a2fe1474b69b65eebc67a61e",
  // "api-key": "12345678900987654321",
  // "api-version": "1.0",
  // "X-Zid":"646ed78a0e42d7572c2302c5"
}


export default {
  // CONFIG

  onSetToken(){
    instance.defaults.headers = {
      "Content-Type": "application/json",
      // "api-version": "1.0",
      "X-Access-Token":  `${store.state.XAccessToken}`,
      // "studentcode" : `${store.state.username}`,
      // "userid" : `${store.state.username}`,
      // "officerid":`${store.state.username}`
    }

  },



  organization(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/organization",data);
      case 'get':
        return instance.get("/api/v1/setting/organization");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/organization", data);
      case 'put':
        return instance.put("/api/v1/setting/organization", data);
      case 'delete':
        return instance.delete("/api/v1/setting/organization");
      default:
        break;
    }
  },

  agency(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/setting/explore/agency",data);
      case 'get':
        return instance.get("/api/v1/setting/agency");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/agency", data);
      case 'put':
        return instance.put("/api/v1/setting/agency", data);
      case 'delete':
        return instance.delete("/api/v1/setting/agency");
      default:
        break;
    }
  },

  agencyChart(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/setting/explore/agency/chart",data);
      case 'get':
        return instance.get("/api/v1/setting/agency/chart");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/agency/chart", data);
      case 'put':
        return instance.put("/api/v1/setting/agency/chart", data);
      case 'delete':
        return instance.delete("/api/v1/setting/agency/chart");
      default:
        break;
    }
  },




  // yourself
  personal(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/personal",data);
      case 'get':
        return instance.get("/api/v1/personal");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/personal", data);
      case 'put':
        return instance.put("/api/v1/personal", data);
      case 'delete':
        return instance.delete("/api/v1/personal", data);
      default:
        break;
    }
  },

  // yourself
  admin(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/admin",data);
      case 'get':
        return instance.get("/api/v1/setting/admin");
      case 'post':
        delete data._id;
        return instance.post("/api/v1/setting/admin", data);
      case 'put':
        return instance.put("/api/v1/setting/admin", data);
      case 'delete':
        return instance.delete("/api/v1/setting/admin", data);
      default:
        break;
    }
  },


  estimatesAssessment(method, data, configs) {
    switch (method){
      case 'exp':
        return instance.post("/api/v1/explore/assessment",data);
      case 'report-status':
        return instance.post("/api/v1/explore/assessment/report/status",data);
      case 'report-gap':
        return instance.post("/api/v1/explore/assessment/report/gaps",data);
      case 'report-group':
        return instance.post("/api/v1/explore/assessment/report/group",data);


      // case 'get':
      //   return instance.get("/api/v1/personal");
      case 'post':
        return instance.post("/api/v1/assessment", data);
      case 'put':
        return instance.put("/api/v1/assessment", data);
      case 'delete':
        return instance.delete("/api/v1/assessment", data);
      default:
        break;
    }
  },
}
